<script>
import ResourceService from '@/services/resources/plant_users_service';
import SiteView from './SiteView.vue';

export default {
  extends: SiteView,
  components: {
    ActionBar: () => import('@/components/action_bars/PlantUsersActionBar.vue'),
  },
  data() {
    return {
      resourceService: ResourceService,
      icon: 'mdi-home-account',
      urlFragment: 'plant-users',
      headers: [
        { text: 'Name', value: 'name' },
        { text: 'Code', value: 'code' },
        { text: 'RFID', value: 'rfid' },
      ],
      sortBy: ['name'],
    };
  },
  computed: {
    resourceParams() {
      return {
        filter: {
          site: this.siteId,
        },
      };
    },
  },
};
</script>
